import axios from "axios";
import * as qs from "qs";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";

export const JobService = {
  addJobNotes,
  updateJobNotes,
  deleteJobNotes,
  notesHistory,
  getJobNotes,
  addTaNotes,
  getTaNotes,
  updateTaNotes,
  deleteNotes,
  createJobReq,
  getJobs,
  getJob,
  generateJobId,
  updateJob,
  copyJobRequest,
  updateJobReqBenefits,
  uploadFile,
  uploadLogo,
  getFiles,
  removeFiles,
  downloadFilesService,
  getJBenefitsService,
  getLanguageService,
  getSoftSkillsService,
  updateSoftSkillsService,
  updateJobReqLanguagesService,
  getReqLanguageService,
  getcertificationService,
  saveCertificationService,
  getSkillsService,
  saveJobReqSkillsService,
  searchSoftSkill,
  searchLanguages,
  searchCertifications,
  searchSkill,
  getReqLanguagesService,
  getReqSoftSkillService,
  getReqSkillService,
  getReqCertificationsService,
  removeReqSkillsService,
  removeReqLanguageService,
  removeSOftSkillsService,
  removecertificationsService,
  activateRequestService,
  closeRequestService,
  getAccountLocationsService,
  getJobCandidateService,
  getCandidateDetails,
  shortlistedCandidateService,
  rejectedCandidateService,
  taActionCompletedService,
  changeApplicantJobStatusService,
  getShortlistReasonService,
  getRejectedReasonService,
  getShortlistedservice,
  getShortlistedCandidatesOnClientSide,
  getTAService,
  getTAactiveService,
  proxyLogin,
  getActiveTAService,
  draftRequest,
  hmsSentRequest,
  hmsFilled,
  hmsOnhold,
  lostRequest,
  addJobLink,
  getJobLinks,
  updateJobLink,
  deleteJobLink,
  cancelledRequest,
  addNotifications,
  getNotificationService,
  updateNotification,
  deleteNotification,
  getDisplayNotes,
  getDisplayNotes,
};
function createJobReq(jobReqObj) {
  return axios({
    method: "post",
    url: ENV.createjob_url,
    headers: {
      Authorization: "Bearer " + window.localStorage.authToken,
    },
    data: jobReqObj,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("Error" + JSON.stringify(error));
      validateErrorResponse(error);
    });
}

function getJobs(
  search,
  statuses,
  priority,
  accountId,
  taId,  
  city,
  state,
  itemsPerPage,
  currentPage,
  sortBy,
  sortOrder
) {
  return axiosInterceptors
    .get(ENV.getJobs_url, {
      params: {
        search: search,
        status: statuses,
        priority: priority,
        accountIds: accountId,
        talentAdvisorIds: taId,
        city:city,
        state:state,
        ps: itemsPerPage,
        pn: currentPage,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
      paramsSerializer: (params) => {
        var qps = qs.stringify(params, { arrayFormat: "repeat" });
        return qps;
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getJob(jobId) {
  return axiosInterceptors
    .get(ENV.getJobUrl + jobId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function generateJobId(accountId) {
  return axiosInterceptors
    .post(ENV.generatejobid_url + accountId + "/generatejobid")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateJob(jobObj, jobId) {
  return axiosInterceptors
    .put(ENV.updateJobUrl + jobId + "/update", jobObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function copyJobRequest(jobId) {
  return axiosInterceptors
    .put(ENV.copyJobUrl + jobId + "/copy")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getTaNotes(applicationId,jobId) {
  return axiosInterceptors
    .get(ENV.getJobUrl + jobId + "/applicants/" + applicationId + "/notes")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateTaNotes(UpdatenotesObj,applicationId,noteid,jobId) {
  // const jobId = window.localStorage.getItem("requestId");
  return axiosInterceptors
    .put(ENV.getJobUrl + jobId + "/applicants/" + applicationId +"/notes/"+noteid,UpdatenotesObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}




function deleteNotes(applicationId, noteId,jobreqid) {
  const jobId = window.localStorage.getItem("requestId");

  return axiosInterceptors
    .delete(
      ENV.getJobUrl +
      jobreqid +
        "/applicants/" +
        applicationId +
        "/notes/" +
        noteId
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addTaNotes(reqObj, applicationId,jobId) {
  // const jobId = window.localStorage.getItem("requestId");
  return axiosInterceptors
    .post(
      ENV.getJobUrl + jobId + "/applicants/" + applicationId + "/notes",
      reqObj
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateJobReqBenefits(benfitsobject) {
  const jobId = window.localStorage.getItem("requestId");
  let updateJobBenfiturl = ENV.updatebenifits_url + jobId + "/benefits";

  return axiosInterceptors
    .put(updateJobBenfiturl, benfitsobject)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function uploadFile(benfitsobject) {
  const jobId = window.localStorage.getItem("requestId");
  let updateDocumentsUrl = ENV.uploadFileUrl + jobId + "/files/upload";
  return axiosInterceptors
    .post(updateDocumentsUrl, benfitsobject)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function uploadLogo(benfitsobject) {
  return axiosInterceptors
    .post(ENV.uploadLogoUrl, benfitsobject)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getFiles(jobId) {
  let getDocumentsUrl = ENV.getFilesUrl + jobId + "/files";
  return axiosInterceptors
    .get(getDocumentsUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function removeFiles(documentId) {
  const jobId = window.localStorage.getItem("requestId");
  let deleteDocumentsUrl =
    ENV.removeFilesUrl + jobId + "/files/" + documentId + "/delete";
  return axiosInterceptors
    .delete(deleteDocumentsUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function downloadFilesService(documentId) {
  const jobId = window.localStorage.getItem("requestId");
  let downloadDocumentsUrl =
    ENV.removeFilesUrl + jobId + "/files/" + documentId + "/download";

  return axiosInterceptors
    .get(downloadDocumentsUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getJBenefitsService(jobId) {
  let getBenefitsUrl = ENV.getJobReqBenefits + jobId + "/benefits";
  return axiosInterceptors
    .get(getBenefitsUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getLanguageService(pageSize, sortOrder) {
  let getLanguagesUrl =
    ENV.getmetaSkills +
    "skillType=LANGUAGE&ps=" +
    pageSize +
    "&sortOrder=" +
    sortOrder;

  return axiosInterceptors
    .get(getLanguagesUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getSoftSkillsService(sortOrder) {
  return axiosInterceptors
    .get(ENV.getmetaSkills + "skillType=SOFT_SKILL&sortOrder=" + sortOrder)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateSoftSkillsService(softSkillObj) {
  const jobId = window.localStorage.getItem("requestId");
  let updateSoftSkillsUrl = ENV.updateJobReqSoftSkills + jobId + "/softskills";

  return axiosInterceptors
    .put(updateSoftSkillsUrl, softSkillObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateJobReqLanguagesService(input) {
  const jobId = window.localStorage.getItem("requestId");
  let jobReqLanguagesUrl = ENV.updateJobReqLanguages + jobId + "/languages";

  return axiosInterceptors
    .put(jobReqLanguagesUrl, input)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getReqLanguageService() {
  const jobId = window.localStorage.getItem("requestId");
  let jobReqLanguagesUrl = ENV.updateJobReqLanguages + jobId + "/languages";

  return axiosInterceptors
    .get(jobReqLanguagesUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getcertificationService() {
  return axiosInterceptors
    .get(ENV.skills_url + "skillType=CERTIFICATION")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function saveCertificationService(requestObj) {
  const jobId = window.localStorage.getItem("requestId");
  let jobReqCertificateUrl =
    ENV.updateJobReqLanguages + jobId + "/certifications";

  return axiosInterceptors
    .put(jobReqCertificateUrl, requestObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getSkillsService() {
  let getSkillUrl = ENV.skills_url + "skillType=SKILL";
  return axiosInterceptors
    .get(getSkillUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function saveJobReqSkillsService(input) {
  const jobId = window.localStorage.getItem("requestId");
  let jobReqSkillsUrl = ENV.updateJobReqLanguages + jobId + "/skills";

  return axiosInterceptors
    .put(jobReqSkillsUrl, input)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function searchSoftSkill(softSkill) {
  return axiosInterceptors
    .get(ENV.getmetaSkills + "skillType=SOFT_SKILL&search=" + softSkill)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function searchLanguages(language) {
  return axiosInterceptors
    .get(ENV.getmetaSkills + "skillType=LANGUAGE&search=" + language)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function searchCertifications(certification) {
  return axiosInterceptors
    .get(ENV.skills_url + "skillType=CERTIFICATION&search=" + certification)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function searchSkill(skill) {
  return axiosInterceptors
    .get(ENV.skills_url + "skillType=SKILL&search=" + skill)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getReqLanguagesService(jobId) {
   return axiosInterceptors
    .get(ENV.updateJobReqLanguages + jobId + "/languages")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getReqSoftSkillService(jobId) {
  return axiosInterceptors
    .get(ENV.updateJobReqLanguages + jobId + "/skills?skillType=SOFT_SKILL")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getReqSkillService(jobId) {
 return axiosInterceptors
    .get(ENV.updateJobReqLanguages + jobId + "/skills?skillType=SKILL")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getReqCertificationsService(jobId) {
 return axiosInterceptors
    .get(ENV.updateJobReqLanguages + jobId + "/skills?skillType=CERTIFICATION")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function removeReqSkillsService(skillId,jobId) {  
  return axiosInterceptors
    .delete(ENV.updateJobReqLanguages + jobId + "/skills/" + skillId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function removeReqLanguageService(LanguageId,jobId) {
  return axiosInterceptors
    .delete(ENV.updateJobReqLanguages + jobId + "/languages/" + LanguageId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function removeSOftSkillsService(softSkillId,jobId) {
  return axiosInterceptors
    .delete(ENV.updateJobReqLanguages + jobId + "/skills/" + softSkillId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function removecertificationsService(certificationId,jobId) {
  return axiosInterceptors
    .delete(ENV.updateJobReqLanguages + jobId + "/skills/" + certificationId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function activateRequestService(id) {
  return axiosInterceptors
    .put(ENV.updateJobReqLanguages + id + "/active")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function closeRequestService(id) {
  return axiosInterceptors
    .put(ENV.updateJobReqLanguages + id + "/closed")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function draftRequest(id) {
  return axiosInterceptors
    .put(ENV.updateJobReqLanguages + id + "/opportunity")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function hmsSentRequest(id) {
  return axiosInterceptors
    .put(ENV.updateJobReqLanguages + id + "/hmssent")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function hmsFilled(id) {
  return axiosInterceptors
    .put(ENV.updateJobReqLanguages + id + "/filled")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function hmsOnhold(id) {
  return axiosInterceptors
    .put(ENV.updateJobReqLanguages + id + "/onhold")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function lostRequest(id) {
  return axiosInterceptors
    .put(ENV.updateJobReqLanguages + id + "/lost")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function cancelledRequest(id) {
  return axiosInterceptors
    .put(ENV.updateJobReqLanguages + id + "/cancelled")
    .then((response) => {
     return response;
    })
    .catch((error) => {
     return error;
    });
}

function getAccountLocationsService(accountId) {
  return axiosInterceptors
    .get(ENV.getAccountsUrl + "/" + accountId + "/addressAndbenefits")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getJobCandidateService(
  jobId,
  candidateStatus,
  appliedWithIn,
  minPreferFitScore,
  maxPreferFitScore,
  minSkillsFitScore,
  maxSkillsFitScore,
  itemsPerPage,
  currentPage,
  sortBy,
  sortOrder
) {
  return axiosInterceptors
    .get(ENV.getJobs_url + "/" + jobId + "/applicants", {
      params: {
        status: candidateStatus,
        appliedWithIn: appliedWithIn,
        minPreferFitScore: minPreferFitScore,
        maxPreferFitScore: maxPreferFitScore,
        minSkillsFitScore: minSkillsFitScore,
        maxSkillsFitScore: maxSkillsFitScore,
        ps: itemsPerPage,
        pn: currentPage,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
      paramsSerializer: (params) => {
        var qps = qs.stringify(params, { arrayFormat: "repeat" });
        return qps;
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getCandidateDetails(applicationId,jobId) {
  // const jobId = window.localStorage.getItem("requestId");
  return axiosInterceptors
    .get(ENV.getJobUrl + jobId + "/applicants/" + applicationId + "/review")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function shortlistedCandidateService(candidateId, reqObj) {
  const jobId = window.localStorage.getItem("requestId");
  return axiosInterceptors
    .put(
      ENV.getJobUrl + jobId + "/candidates/" + candidateId + "/shortlisted",
      reqObj
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function rejectedCandidateService(candidateId, reqObj) {
  const jobId = window.localStorage.getItem("requestId");
  return axiosInterceptors
    .put(
      ENV.getJobUrl + jobId + "/candidates/" + candidateId + "/reject",
      reqObj
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function taActionCompletedService(candidateId,jobId) {
  // const jobId = window.localStorage.getItem("requestId");
  return axiosInterceptors
    .put(ENV.getJobUrl + jobId + "/applicants/" + candidateId + "/ta/acted")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function changeApplicantJobStatusService(candidateId, reqObj,jobId) {
  return axiosInterceptors
    .put(
      ENV.getJobUrl + jobId + "/applicants/" + candidateId + "/status",
      reqObj
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getShortlistReasonService(applicantid,jobId) {
  return axiosInterceptors
    .get(
      ENV.getJobUrl +
        jobId +
        "/applicants/" +
        applicantid +
        "/shortlistedReasons"
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getRejectedReasonService(applicantid,jobId) {
  return axiosInterceptors
    .get(
      ENV.getJobUrl + jobId + "/applicants/" + applicantid + "/rejectReasons"
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getShortlistedservice(jobId) {
  return axiosInterceptors
    .get(ENV.getshortlisted_url + jobId + "/shortlisted/candidates/ta")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getShortlistedCandidatesOnClientSide(hmsId, selectedStatus) {
  return axiosInterceptors
    .get(ENV.hmsUrl + hmsId + "/applicants?status=" + selectedStatus)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getTAService() {
  return axiosInterceptors
    .get(ENV.getTAsUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getActiveTAService() {
  return axiosInterceptors
    .get(ENV.getActiveTAsUrl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getTAactiveService() {
  return axiosInterceptors
    .get(ENV.getTAsactiveUrl + "?status=" + "ACTIVE")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function proxyLogin(candidateId) {
  return axiosInterceptors
    .post(ENV.proxyLoginUrl + candidateId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addJobLink(jobReqObj, jobId) {
  return axiosInterceptors
    .post(ENV.createjob_url + "/" + jobId + "/links", jobReqObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getJobLinks(jobId) {
  return axiosInterceptors
    .get(ENV.createjob_url + "/" + jobId + "/links")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateJobLink(jobReqObj, jobId, jobLinkId) {
  return axiosInterceptors
    .put(ENV.createjob_url + "/" + jobId + "/links/" + jobLinkId, jobReqObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function deleteJobLink(jobId, jobLinkId) {
  return axiosInterceptors
    .delete(ENV.createjob_url + "/" + jobId + "/links/" + jobLinkId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getJobNotes(jobId) {
  return axiosInterceptors
    .get(ENV.createjob_url + "/" + jobId + "/notes")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function addJobNotes(notesObj, jobId) {
  return axiosInterceptors
    .post(ENV.createjob_url + "/" + jobId + "/notes", notesObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateJobNotes(notesObj, jobId, noteId) {
  return axiosInterceptors
    .put(ENV.createjob_url + "/" + jobId + "/notes/" + noteId, notesObj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}
function deleteJobNotes(jobId, noteId) {
  return axiosInterceptors
    .delete(ENV.createjob_url + "/" + jobId + "/notes/" + noteId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}


function notesHistory(applicationId,id){



  return axiosInterceptors
  .get(ENV.notesHistory_url + id +"/applicants/"+applicationId+"/notes/history")
  
  .then((response) =>{
    return response
  })
  .catch((error)=>{
    return error;
  })
}

function addNotifications(obj) {
  console.log("responce___notificationinput"+JSON.stringify(obj))
  return axiosInterceptors
    .post(ENV.notificationurl,obj)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}


function getNotificationService() {
  return axiosInterceptors
    .get(ENV.notificationurl)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function updateNotification(id) {
  return axiosInterceptors
    .put(ENV.notificationurl + id+"/read",)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function deleteNotification(deleteid) {
  return axiosInterceptors
    .delete(ENV.notificationurl +deleteid+"/delete")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

function getDisplayNotes(jobId) {
  return axiosInterceptors
   .get(ENV.createjob_url + "/" + jobId + "/status"+"/history")
   .then((response) => {
    return response;
   })
   .catch((error) => {
    return error;
   });
 }


